const dialogGroups = [
    {
        key: 'opening_1',
        audioStart: 0,
        length: 3500,
        animations: ['ava_gesture_talk_05', 'ava_idle_notalk_01'],
        comment: { text: 'Hello there, how may I help you?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_2',
        audioStart: 4,
        length: 3500,
        animations: ['ava_gesture_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'Good to see you. What can I help you find today?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_3',
        audioStart: 8,
        length: 3500,
        animations: ['ava_gesture_talk_08', 'ava_idle_notalk_01'],
        comment: { text: 'Good to see you. How may I help you?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_4',
        audioStart: 12,
        length: 3500,
        animations: ['ava_gesture_talk_06', 'ava_idle_notalk_01'],
        comment: { text: 'Good to see you. What can I help you find today?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_5',
        audioStart: 16,
        length: 3500,
        animations: ['ava_gesture_talk_03', 'ava_idle_notalk_01'],
        comment: { text: 'Good to see you. Do you have a question for me?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_6',
        audioStart: 20,
        length: 3500,
        animations: ['ava_turn_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'Hello there. What would you like to know?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_7',
        audioStart: 24,
        length: 3500,
        animations: ['ava_idle_talk_01', 'ava_idle_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'Hello there. How may I be of assistance?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_8',
        audioStart: 28,
        length: 3500,
        animations: ['ava_gesture_talk_08', 'ava_idle_notalk_01'],
        comment: { text: 'Hello there. Can I help you find something?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_9',
        audioStart: 32,
        length: 3500,
        animations: ['ava_turn_talk_03', 'ava_idle_notalk_01'],
        comment: { text: 'Good to see you. Can I help you find something?', isAva: true },
        groupType: 'opening'
    },
    {
        key: 'opening_10',
        audioStart: 36,
        length: 3500,
        animations: ['ava_turn_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'Good question. Take a look at what I found?', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_11',
        audioStart: 40,
        length: 4500,
        animations: ['ava_turn_talk_04', 'ava_idle_notalk_01'],
        comment: { text: 'That\'s a pretty good question. Here\'s what I found for you.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_12',
        audioStart: 45,
        length: 3500,
        animations: ['ava_gesture_talk_06', 'ava_idle_notalk_01'],
        comment: { text: 'Ok, here\'s what I found for you.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_13',
        audioStart: 49,
        length: 3500,
        animations: ['ava_gesture_talk_03', 'ava_idle_notalk_01'],
        comment: { text: 'Great question. Take a look at what I found.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_14',
        audioStart: 53,
        length: 3500,
        animations: ['ava_gesture_talk_08', 'ava_idle_notalk_01'],
        comment: { text: 'Good question. Here\'s what I found for you.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_15',
        audioStart: 57,
        length: 3500,
        animations: ['ava_turn_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'Good question. Take a look at what I found.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_16',
        audioStart: 61,
        length: 4900,
        animations: ['ava_gesture_talk_07', 'ava_idle_notalk_01'],
        comment: { text: 'Good question. I found the content you were looking for.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_17',
        audioStart: 66,
        length: 4500,
        animations: ['ava_gesture_talk_05', 'ava_idle_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'Good question. I think I have what you were looking for.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_18',
        audioStart: 71,
        length: 5500,
        animations: ['ava_turn_talk_04', 'ava_idle_notalk_01'],
        comment: { text: 'That is a pretty good question. I think I have what you were looking for.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_19',
        audioStart: 77,
        length: 3500,
        animations: ['ava_turn_talk_03', 'ava_idle_notalk_01'],
        comment: { text: 'Ok, take a look at what I found.', isAva: true },
        groupType: 'answer'
    },
    {
        key: 'opening_20',
        audioStart: 81,
        length: 5500,
        animations: ['ava_gesture_talk_09', 'ava_idle_notalk_01'],
        comment: { text: 'I apologize. I am not able to find a match. Please try again.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_21',
        audioStart: 87,
        length: 6500,
        animations: ['ava_idle_talk_01', 'ava_gesture_talk_09', 'ava_idle_notalk_01'],
        comment: { text: 'That\'s strange, I could not find the content you were looking for. Can I try to look for something else?', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_22',
        audioStart: 94,
        length: 7500,
        animations: ['ava_turn_talk_02', 'ava_gesture_talk_02', 'ava_idle_notalk_01'],
        comment: { text: 'I\'m sorry, I could not find the content you were looking for. Maybe a different search will provide a better result.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_23',
        audioStart: 102,
        length: 5500,
        animations: ['ava_gesture_talk_02', 'ava_idle_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'I\'m sorry, I could not find what you were looking for. Can I try to look for something else?', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_24',
        audioStart: 108,
        length: 6500,
        animations: ['ava_turn_talk_04', 'ava_idle_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'I\'m sorry, I was not able to find a match. Maybe a different search will provide a better result.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_25',
        audioStart: 115,
        length: 4500,
        animations: ['ava_gesture_talk_07', 'ava_idle_notalk_01'],
        comment: { text: 'I\'m sorry, I was not able to find a match. Please try again.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_26',
        audioStart: 120,
        length: 7500,
        animations: ['ava_turn_talk_01', 'ava_gesture_talk_03', 'ava_idle_notalk_01'],
        comment: { text: 'I apologize. I could not find the content you were looking for. Maybe a different search will provide a better result.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_27',
        audioStart: 128,
        length: 6500,
        animations: ['ava_turn_talk_03', 'ava_idle_talk_01', 'ava_idle_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'I apologize. I could not find the content you were looking for. Can I try to look for something else?', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_28',
        audioStart: 135,
        length: 4500,
        animations: ['ava_gesture_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'I apologize. I could not find the content you were looking for.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_29',
        audioStart: 140,
        length: 7500,
        animations: ['ava_gesture_talk_08', 'ava_turn_talk_02', 'ava_idle_notalk_01'],
        comment: { text: 'That\'s strange, I could not find what you were looking for. Maybe a different search will provide a better result.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_30',
        audioStart: 148,
        length: 7500,
        animations: ['ava_turn_talk_01', 'ava_gesture_talk_02', 'ava_idle_notalk_01'],
        comment: { text: 'That\'s strange, I am not able to find a match. Can I try to look for something else?', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_31',
        audioStart: 156,
        length: 5500,
        animations: ['ava_gesture_talk_09', 'ava_idle_notalk_01'],
        comment: { text: 'Hmmm, I could not find what you were looking for. Please try again.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'opening_32',
        audioStart: 162,
        length: 6500,
        animations: ['ava_gesture_talk_01', 'ava_idle_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'Hmmm, I am not able to find a match. Maybe a different search will provide a better result.', isAva: true },
        groupType: 'noanswer'
    },
    {
        key: 'noanswer_01',
        audioStart: 140,
        length: 7500,
        animations: ['ava_turn_talk_01', 'ava_gesture_talk_02', 'ava_idle_notalk_01'],
        comment: { text: 'That\'s strange, I could not find what you were looking for. I\'ll submit this question for review.', isAva: true },
        groupType: 'noanswer1'
    },
    {
        key: 'noanswer_02',
        audioStart: 140,
        length: 7500,
        animations: ['ava_turn_talk_01', 'ava_gesture_talk_02', 'ava_idle_notalk_01'],
        comment: {
            text: 'That\'s strange, I could not find what you were looking for. If you need more help visit the help site by clicking on the link below.',
            isAva: true,
            buttons: [{ type: 'callParent', value: 'openHelp', title: 'Launch Help' }]
        },
        groupType: 'noanswer2'
    },
    {
        key: 'opening_33',
        audioStart: 169,
        length: 9500,
        animations: ['ava_gesture_talk_07', 'ava_turn_talk_04', 'ava_idle_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'Hi, I\'m AVA. I\'m here to help you with any questions that you may have. To start, simply type in a question, and I\'ll do my best to respond to it.', isAva: true },
        groupType: 'idle-first'
    },
    {
        key: 'opening_34',
        audioStart: 179,
        length: 11500,
        animations: ['ava_gesture_talk_09', 'ava_turn_talk_01', 'ava_gesture_talk_03', 'ava_idle_talk_01', 'ava_idle_notalk_01'],
        comment: { text: 'In case you are wondering, you can ask me any questions such as How do I create an Avatar, How do I recover my Password, or Where can I find the Map, plus so much more.', isAva: true },
        groupType: 'idle-second'
    },
    {
        key: 'opening_35',
        audioStart: 191,
        length: 7500,
        animations: ['ava_gesture_talk_06', 'ava_gesture_talk_02', 'ava_idle_notalk_01'],
        comment: {
            text: 'You can also visit the help website at any time to get more help. Click on the link below to go there.',
            isAva: true,
            buttons: [{ type: 'callParent', value: 'openHelp', title: 'Launch Help' }]
        },
        groupType: 'idle-third'
    },
    {
        key: 'answer_000',
        audioStart: 0,
        length: 0,
        animations: ['ava_idle_notalk_01'],
        comment: { text: '', isAva: false },
        groupType: 'question'
    },
    {
        key: 'error_000',
        audioStart: 0,
        length: 0,
        animations: ['ava_idle_notalk_01'],
        comment: {
            text: 'I\'m sorry, something went wrong and I need to be restarted.Please click the "X" button above the text field.Then bring me back up by clicking on my icon in the top right corner of the screen.', isAva: true },
        groupType: 'error'
    }
]

export default {
    getDialogGroupByType(cb, data) {
        let groups = _.filter(dialogGroups, { 'groupType': data.groupType });
        let group = _.sample(groups);
        cb(group);
    },
    getDialogGroupByKey(cb, data) {
        let group = _.find(dialogGroups, { 'key': data });
        cb(group);
    },
    getAllDialogGroups() {
        return dialogGroups;
    }
}
